import React from 'react';
import { defineMessages } from 'react-intl';
import { generatePath, useLocation, useParams } from 'react-router-dom';
import PageWrapper from '@components/common/layout/PageWrapper';
import apiConfig from '@constants/apiConfig';
import { errorCodes } from '@constants/ErrorCode';
import useSaveBase from '@hooks/useSaveBase';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import routes from '@routes';
import { showErrorMessage } from '@services/notifyService';

import AreaForm from './AreaForm';

const message = defineMessages({
    objectName: 'Area',
});

const KitplayAreaSavePage = () => {
    const translate = useTranslate();
    const params = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab');
    const deviceId = queryParams.get('deviceId');
    const restaurantId = queryParams.get('restaurantId');
    const restaurantName = queryParams.get('restaurantName');
    const ordering = queryParams.get('ordering');

    const { detail, mixinFuncs, loading, setIsChangedFormValues, isEditing, title, setSubmit } = useSaveBase({
        apiConfig: {
            getById: apiConfig.areas.getById,
            create: apiConfig.areas.create,
            update: apiConfig.areas.update,
        },
        options: {
            getListUrl: generatePath(routes.deviceTabsRestaurantListPage.path, { customerId: params.customerId }) + `?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}`,
            objectName: translate.formatMessage(message.objectName),
        },
        override: (funcs) => {
            funcs.prepareUpdateData = (data) => {
                return {
                    ...data,
                    id: detail.id,
                    restaurantId,
                    deviceId,
                };
            };
            funcs.prepareCreateData = (data) => {
                return {
                    ...data,
                    restaurantId,
                    deviceId,
                    ordering: ordering ? Number(ordering) : undefined,
                };
            };
            funcs.onSaveError = (err) => {
                const errorCode = err.response?.data?.code;
                const errorMessage = errorCodes[errorCode]?.message;
                if (errorMessage) {
                    showErrorMessage(errorMessage, translate);
                    setSubmit(false);
                } else {
                    mixinFuncs.handleShowErrorMessage(err, showErrorMessage);
                    setSubmit(false);
                }
            };
        },
    });

    return (
        <PageWrapper
            loading={loading}
            routes={[
                {
                    breadcrumbName: translate.formatMessage(commonMessage.digibesShop),
                    path: routes.shopAccountListPage.path,
                },
                {
                    breadcrumbName: translate.formatMessage(commonMessage.restaurant),
                    path: generatePath(routes.RestaurantByCustomerListPage.path,{ customerId: params.customerId }),
                },
                {
                    breadcrumbName: restaurantName || translate.formatMessage(commonMessage.devices),
                    path: `${generatePath(routes.deviceTabsRestaurantListPage.path, {
                        customerId: params.customerId,
                    })}?tab=${tab}&restaurantId=${restaurantId}&restaurantName=${restaurantName}`,
                },
                { breadcrumbName: title },
            ]}
            title={title}
        >
            <AreaForm
                setIsChangedFormValues={setIsChangedFormValues}
                dataDetail={detail ? detail : {}}
                formId={mixinFuncs.getFormId()}
                isEditing={isEditing}
                actions={mixinFuncs.renderActions()}
                onSubmit={mixinFuncs.onSave}
            />
        </PageWrapper>
    );
};

export default KitplayAreaSavePage;
